import { useEffect, useRef } from 'react';
var getIsIOSSafari = function getIsIOSSafari() {
  var _window, _window2;
  var isIos = /iP(ad|od|hone)/i.test((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent);
  var isSafari = !!((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.navigator) !== null && _window2 !== void 0 && (_window2 = _window2.userAgent) !== null && _window2 !== void 0 && _window2.match(/Version\/[\d.]+.*Safari/));
  return isIos && isSafari;
};
export var useBlockMobileNavigation = function useBlockMobileNavigation() {
  var elementsRef = useRef([]);
  var isIOSSafari = getIsIOSSafari();
  var inputRef = useRef(null);
  var setFlags = function setFlags(flag) {
    var _elementsRef$current;
    (_elementsRef$current = elementsRef.current) === null || _elementsRef$current === void 0 || _elementsRef$current.forEach(function (el) {
      el.disabled = flag;
    });
  };
  var blockAll = function blockAll() {
    if (isIOSSafari) {
      elementsRef.current = [];
      var elements = document.querySelectorAll('input,select,textarea');
      for (var i = 0; i < elements.length; i += 1) {
        var element = elements.item(i);
        if (!element.isEqualNode(inputRef.current)) {
          elementsRef.current.push(element);
        }
      }
      setFlags(true);
    }
  };
  var onFocus = function onFocus() {
    blockAll();
  };
  var onBlur = function onBlur() {
    setFlags(false);
  };
  useEffect(function () {
    blockAll();
    return function () {
      return setFlags(false);
    };
  }, [isIOSSafari]);
  return {
    inputRef: inputRef,
    onFocus: onFocus,
    onBlur: onBlur
  };
};